import { useCallback, useEffect, useState } from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import MenuItem from '@mui/material/MenuItem'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */
import useStyles from 'features/setting/default-users/frequencies-alcohols/style'

/** API */
import FrequenciesAlcoholApi from 'api/setting/default-users/frequencies-alcohol.api'

/** UTILS || SLICE */
import { submitModal, unSubmitModal, showModal, resetModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { swalActive } from 'component/Alert/Swal'
import ButtonCustom from 'component/Button/ButtonCustom'
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputTextField from 'component/Input/InputTextField'
import InputTextSearch from 'component/Input/InputTextSearch'
import ModalCustom from 'component/ModalCustom/ModalCustom'
import TableCustom from 'component/Table/TableCustom'
import { notiSuccess, notiError } from 'component/notifications/notifications'
import TableRowCommon from 'component/Table/TableRowCommon'
import FilterSelect from 'component/Select/FilterSelect'
import AlertModal from 'new-components/modal/alert-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'
import PageModal from 'new-components/modal/page-modal'
import TextInput from 'new-components/inputs/text-input'
import CheckboxButton from 'new-components/buttons/checkbox-button'
import SwitchButton from 'new-components/buttons/switch-button'
import { Box } from '@mui/material'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

const initStateErrorMessage = {
  FREQUENCIES_NAME: ``,
  IS_DUPLICATE_FREQUENCIES_NAME: ``,
  FREQUENCIES_NAME_STRING_BASE: ``,
  FREQUENCIES_NAME_STRING_EMPTY: ``,
  FREQUENCIES_NAME_MAXIMUM_LENGTH: ``,
  FREQUENCIES_NAME_ANY_REQUIRED: ``,

  FREQUENCIES_NAME_EN: ``,
  IS_DUPLICATE_FREQUENCIES_NAME_EN: ``,
  FREQUENCIES_NAME_EN_STRING_BASE: ``,
  FREQUENCIES_NAME_EN_STRING_EMPTY: ``,
  FREQUENCIES_NAME_EN_MAXIMUM_LENGTH: ``,
  FREQUENCIES_NAME_EN_ANY_REQUIRED: ``
}
export default function FrequenciesAlcohols() {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [frequencice, setFrequencies] = useState([])

  const [frequencyId, setFrequencyId] = useState(Number)
  const [frequencyName, setFrequencyName] = useState('')
  const [frequencyStatus, setFrequencyStatus] = useState('')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')

  const [isPopup, setIsPopup] = useState(false)

  const loadData = useCallback(async () => {

    let condition: any = {}
    if (page) condition = { ...condition, page: page }
    if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
    if (search) condition = { ...condition, search: search }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (status) condition = { ...condition, status: status === 'ALL' ? '' : status }

    const res = await FrequenciesAlcoholApi.findAll(condition)
    if (res.status === 200) {
      setRowCount(res.headers['x-total'])
      setFrequencies(res.data)
    }
  }, [page, pageLimit, search, sortBy, sortType, status])

  useEffect(() => {
    loadData()
  }, [loadData])

  const submit = () => {
    if (!frequencyName) return setErrorMessage({ ...errorMessage, ...{ FREQUENCIES_NAME: t('FREQUENCIES_ALCOHOL.MESSAGE.FREQUENCIES_NAME') } })

    dispatch(submitModal())
    FrequenciesAlcoholApi.create(frequencyName)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('FREQUENCIES_ALCOHOL.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`FREQUENCIES_ALCOHOL.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`FREQUENCIES_ALCOHOL.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      })
  }

  const submitEdit = () => {
    if (!frequencyName) return setErrorMessage({ ...errorMessage, ...{ FREQUENCIES_NAME: t(`FREQUENCIES_ALCOHOL.MESSAGE.FREQUENCIES_NAME`) } })

    dispatch(submitModal())
    FrequenciesAlcoholApi.update(frequencyId, { frequencyName, status: frequencyStatus })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`FREQUENCIES_ALCOHOL.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data

          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`FREQUENCIES_ALCOHOL.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`FREQUENCIES_ALCOHOL.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }
  const resetForm = () => {
    setFrequencyId(0)
    setFrequencyName('')
    setFrequencyStatus('')
    setIsPopup(false)
    clearErrorMessage()
  }
  const onActive = () => {
    if (id) {
      FrequenciesAlcoholApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('FREQUENCIES_ALCOHOL.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('FREQUENCIES_ALCOHOL.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = () => {
    if (id) {
      FrequenciesAlcoholApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('FREQUENCIES_ALCOHOL.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('FREQUENCIES_ALCOHOL.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { frequencyId: fqcId, frequencyName: fqcName, status: fqcStatus } = data
    setFrequencyId(fqcId)
    setFrequencyName(fqcName)
    setFrequencyStatus(fqcStatus)
    setIsPopup(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: '#' },
    { id: 'frequencyName', disablePadding: false, label: t('FREQUENCIES_ALCOHOL.TABLE.CELL.FREQUENCIES_NAME') },
    { id: 'status', disablePadding: false, label: t('FREQUENCIES_ALCOHOL.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('FREQUENCIES_ALCOHOL.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { frequencyId: fqcId, frequencyName: fqcName, updatedBy, updatedAt, status: fqcStatus } = objData
    const statusBtnActive = fqcStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = fqcStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled
    const objRenderData = {
      key: fqcId,
      id: fqcId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: fqcName },
        { option: 'STATUS', align: 'center', label: fqcStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.frequencyName)
    setNameEn(obj.frequencyNameEn)
  }

  return (
    <div className={classes.root}>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`FREQUENCIES_ALCOHOL.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`FREQUENCIES_ALCOHOL.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { frequenciesName: name, frequenciesNameEn: nameEn && `(${nameEn})`, status: t(`FREQUENCIES_ALCOHOL.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <Card className="border-0 h-100">
        <HeaderCard text={t('FREQUENCIES_ALCOHOL.TITLE')} />
        <Card.Body>
          <Card.Title className={'mb-0 pl-xl-3'}>
            <Row className="align-items-center">
              <Col md={8}>
                <Row className="flax-row">
                  <Col sm={12} md={6} xl={4} className="pt-2">
                    <InputTextSearch
                      keyInput={'search'}
                      label={t('FREQUENCIES_ALCOHOL.SEARCH')}
                      value={search}
                      onchange={(event) => {
                        setSearch(event.target.value)
                        setPage(1)
                      }}
                      onClear={(event) => {
                        setSearch('')
                        setPage(1)
                      }}
                    />
                  </Col>
                  <Col sm={12} md={6} xl={4} className="pl-md-0 pt-2">
                    <FilterSelect
                      onchange={(event) => {
                        const value = event.target.value
                        if (value) {
                          handleChangeStatus(value)
                          setPage(1)
                        }
                      }}
                      renderValue={() => `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}`}
                      label={t('STATUS.LABEL')}
                      selectId="select-status"
                      value={status}
                      labelId="label-status"
                      options={[
                        <MenuItem key="1" value="ALL">
                          {t('STATUS.ALL')}
                        </MenuItem>,
                        <MenuItem key="2" value="ACTIVE">
                          {t('STATUS.ACTIVE')}
                        </MenuItem>,
                        <MenuItem key="3" value="INACTIVE">
                          {t('STATUS.INACTIVE')}
                        </MenuItem>
                      ]}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md={4} className="mt-2 mt-md-auto">
                <div className="pr-xl-2">
                  <ButtonCustom mode="add" disabled={permissions.isCreate.disabled} onClick={() => setIsPopup(true)} textButton={t('FREQUENCIES_ALCOHOL.BUTTON.ADD')} className="w-auto ml-auto d-flex mt-auto" />
                </div>
              </Col>
            </Row>
          </Card.Title>

          <div className={'mt-3 pl-xl-3 pr-xl-2'}>
            <TableCustom
              page={page}
              pageLimit={pageLimit}
              sortType={sortType}
              sortBy={sortBy}
              onSort={onRequestSort}
              setPageLimit={handleChangeRowsPerPage}
              setPage={handleChangePage}
              rowCount={rowCount}
              headCells={headCells}
              rowsData={frequencice.map((val, i) => {
                return renderData(val, i)
              })}
            />
          </div>
        </Card.Body>
      </Card>

      <PageModal
        title={frequencyId ? t('FREQUENCIES_ALCOHOL.TITLE_UPDATE') : t('FREQUENCIES_ALCOHOL.TITLE_CREATE')}
        isOpen={isPopup}
        onCancel={{ onClick: () => resetForm() }}
        onSubmit={{ onClick: () => frequencyId ? submitEdit() : submit() }}
        handleClose={resetForm}
        size={'XS'}
      >
        <Box className="py-2">
          {frequencyId ? (
            <Form className="mx-0 mt-0 mb-3 p-0 d-inline-flex w-100">
              <Form.Label className=" mr-auto">{t('INPUT.LABEL_STATUS')}</Form.Label>
              <SwitchButton
                onChange={() => setFrequencyStatus(frequencyStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')}
                checked={frequencyStatus === 'ACTIVE' ? true : false}
              />
            </Form>
          ) : (
            ''
          )}

          <TextInput
            fullWidth
            onChange={(event) => {
              setFrequencyName(event.target.value)
              clearErrorMessage()
            }}
            value={frequencyName}
            label={t('FREQUENCIES_ALCOHOL.INPUT.FREQUENCIES_NAME')}
            helperText={
              errorMessage.FREQUENCIES_NAME ||
              errorMessage.IS_DUPLICATE_FREQUENCIES_NAME ||
              errorMessage.FREQUENCIES_NAME_STRING_BASE ||
              errorMessage.FREQUENCIES_NAME_STRING_EMPTY ||
              errorMessage.FREQUENCIES_NAME_MAXIMUM_LENGTH ||
              errorMessage.FREQUENCIES_NAME_ANY_REQUIRED
            }
            required={true}
          />
        </Box>
      </PageModal>

    </div>
  )
}
